import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { Typography } from "@mui/material";
import { HStack } from "Components/_Shared/Core/Stack";
import { Spacing } from "Infrastructure/Themes/Themes";

export const DialogErrorText = ({ text }: { readonly text: string }) => (
  <HStack role="alert" alignItems="flex-start" spacing={Spacing.S} color="error.main">
    <ErrorOutlineIcon fontSize="small" />
    <Typography variant="body2" color="inherit">
      {text}
    </Typography>
  </HStack>
);
